<template>
  <div>
    <v-row class="mt-8 mb-1" no-gutters>
      <span
        class="font-weight-medium"
        :class="{ 'neutral--text text--lighten-1': !$vuetify.theme.dark }"
        >{{ title }}</span
      >
      <v-chip class="ml-2 panda-ia-chip" small
        ><span class="font-weight-medium neutral--text text--lighten-1">{{
          $i18next.t('message.ai.ai')
        }}</span></v-chip
      >
    </v-row>

    <div
      v-for="(item, i) of itemsList"
      :key="item.country + i"
      class="list-item__bordered f-width py-3 d-flex align-center justify-space-between"
    >
      <div class="d-flex align-center">
        <country-flag :country="item.country" class="list-item__flag" />
        <span
          class="font-weight-regular text-subtitle-2"
          style="line-height: 1px"
          :class="{ 'neutral--text text--lighten-1': !$vuetify.theme.dark }"
        >
          {{ item.label }}
        </span>
      </div>
      <div class="d-flex align-end">
        <BaseBtn type="secondary" size="xsmall" @click="btnDefaultAction">{{
          btnText
        }}</BaseBtn>
      </div>
    </div>
  </div>
</template>

<script>
import CountryFlag from 'vue-country-flag'
import BaseBtn from '@/components/BaseBtn.vue'

export default {
  name: 'SuggestedAiWorkflows',
  components: { CountryFlag, BaseBtn },
  props: {
    title: {
      type: String,
      required: true,
    },
    btnText: {
      type: String,
      required: true,
    },
    btnDefaultAction: {
      type: Function,
      required: true,
    },
    itemsList: {
      type: Array,
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/src/_ai_works';

.panda-ia-chip {
  background: var(--v-brand-lighten2) !important;
}
</style>
